import { isObject } from '@aviata/type-guards';
import type {
  AdditionalProduct,
  TicketProduct,
  AncillaryProduct,
  Product,
} from './products';

export const isTicket = (product: Product): product is TicketProduct =>
  isObject(product) &&
  'data' in product &&
  'offer' in product.data &&
  'booking' in product.data &&
  'dict' in product.data &&
  'passengers' in product.data;

export const isAdditionalProduct = (
  product: Product,
): product is AdditionalProduct =>
  isObject(product) &&
  'data' in product &&
  '$meta' in product.data &&
  'full_description' in product.data.$meta &&
  'short_description' in product.data.$meta;

export const isAncillary = (product: Product): product is AncillaryProduct =>
  isObject(product) &&
  'data' in product &&
  'code' in product.data &&
  'passenger_idx' in product.data &&
  'price' in product.data &&
  'pricing' in product.data &&
  'segments' in product.data;
